// extracted by mini-css-extract-plugin
module.exports = {"wheel":"styles_wheel__h04VZ","item":"styles_item__qfMGO","selected":"styles_selected___ShE_"};